const fetchImage = require("./fetchImage");
const validateYouTubeUrl = require("./validateYouTubeUrl");
const validateVimeoUrl = require("./validateVimeoUrl");
const slugify = require("./slugify");
const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

/**
 * Take richtext coming from drupal CKEditor and convert to renderable HTML
 * @param str: plain richtext (html)
 * @returns
 */

module.exports = async function transformText(str, authContext) {
	if (str === null || str === "") return "";
	str = str
		.replace(/<table>/g, '<div class="table-responsive"><table>')
		.replace(/<\/table>/g, "</table></div>")
		.replace(/\r?\n|\r|\t/g, " ")
		.replace(/src="\/system/g, `src="${generalSettings.data.siteMetaData.drupalUrl}`)
		.replace(
			/src="\/sites/g,
			`src="${generalSettings.data.siteMetaData.drupalUrl}/sites`
		);

	["h1", "h2", "h3", "h4", "h5", "h6"].forEach((hname) => {
		str = str.replace(
			new RegExp(`<${hname}([^>]*)>(.*?)<\\/${hname}>`, "gs"),
			function (m, attrs, content) {
				let title = content.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ");
				let id = slugify(title);
				return `<${hname} id="${id}" class="font variant-${hname} MuiTypography MuiTypography-root MuiTypography-${hname}">${content}</${hname}>`;
			}
		);
	});

	str = str.replace(/<\s*figure[^>]*>(.*?)<\s*\/\s*figure>/g, function (m) {
		let attrs = m
			.toString()
			.match(/(\w+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/g);
		let caption = m.toString().match(/<\s*figcaption[^>]*>(.*?)<\s*\/\s*figcaption>/g);
		if (attrs) {
			if (caption) {
				caption = caption[0].match(/(?<=<.+.>)(.*?)(?=<.*\/.+.?>)/g);
			}
			let img_attrs = {
				"data-entity-type": "file",
			};
			if (caption) {
				let the_caption = "";
				for (let i = 0; i < caption.length; i++) {
					if (caption[i].length > the_caption.length) {
						the_caption = caption[i];
					}
				}
				img_attrs["data-caption"] = the_caption;
			}
			for (const attr of attrs) {
				let [attr_key, attr_val] = attr.split("=");
				if (attr_key === "src") {
					img_attrs.src = attr_val.replace(/"/g, "");
					img_attrs["data-entity-uuid"] = attr_val
						.replace(/"/g, "")
						.split("/")
						.pop()
						.split(".")[0];
				} else if (attr_key === "width") {
					img_attrs.width = attr_val.replace(/"/g, "");
				} else if (attr_key === "alt") {
					img_attrs.alt = attr_val.replace(/"/g, "");
				} else if (attr_key === "style" && attr_val.includes("float:")) {
					img_attrs["data-align"] = attr_val.includes("float: left") ? "left" : "right";
				}
			}
			let figure_html = "<img ";
			for (const attr in img_attrs) {
				figure_html += `${attr}="${img_attrs[attr]}" `;
			}
			figure_html += " />";
			return figure_html;
		}
		return m;
	});

	// convert img with caption attr
	let images = [];
	str.replace(/<\s*img[^>]*>/g, function (m) {
		let media_data = {};
		const attrs = m
			.toString()
			.match(/(\w+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/g);
		if (attrs) {
			for (const attr of attrs) {
				let attr_arr = attr.split("=");
				if (attr_arr.length === 2) {
					media_data[attr_arr[0]] = attr_arr[1].replace(/"/g, "");
				}
			}
		}
		if (media_data.caption) {
			let rich_caption = media_data.caption.split("|");
			if (rich_caption.length === 2) {
				media_data.caption = `<em>${rich_caption[0]}</em> ${rich_caption[1]}`;
			}
		}

		if (!media_data.width) {
			media_data.width = media_data.align ? "50%" : "100%";
			media_data.width_undefined = true;
		}
		images.push(media_data);

		return m;
	});

	str = str.replace(/<\s*img[^>]*>/g, function (m) {
		let img_html = "";
		const img_uuid = m.toString().match(/data-entity-uuid\=\"([A-Za-z0-9 _-]*)\"/);
		if (img_uuid) {
			let img = images.find((i) => i.uuid === img_uuid[1]);
			if (img.caption) {
				img.caption = unescapeHTML(img.caption);
			}
			img_html = transformDataToImg(img);
		}
		return img_html ? img_html : m;
	});

	let inlineMedia = [];
	str.replace(/<\s*drupal-media[^>]*>(.*?)<\s*\/\s*drupal-media>/g, function (m) {
		const img_uuid = m.toString().match(/data-entity-uuid\=\"([A-Za-z0-9 _-]*)\"/);
		if (img_uuid) {
			let media_data = {};
			const attrs = m
				.toString()
				.match(/(\w+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/g);
			if (attrs) {
				for (const attr of attrs) {
					let attr_arr = attr.split("=");
					if (attr_arr.length === 2) {
						media_data[attr_arr[0]] = attr_arr[1].replace(/"/g, "");
					}
				}
			}
			if (media_data.caption) {
				let rich_caption = media_data.caption.split("|");
				if (rich_caption.length === 2) {
					media_data.caption = `<em>${rich_caption[0]}</em> ${rich_caption[1]}`;
				}
			}
			inlineMedia.push(media_data);
			return m;
		} else {
			return "";
		}
	});

	const mediaReponses = await Promise.all(
		inlineMedia.map(async (ref) => {
			let img = await fetchImage(
				{
					id: ref.uuid,
					type: "media--image",
				},
				authContext
			);
			if (img) {
				if (ref.caption && ref.caption.length > 0)
					img.caption = unescapeHTML(ref.caption);
				if (ref.alt && ref.alt.length > 0) img.alt = ref.alt;
				img.align = ref.align;
				img.id = ref.uuid;
				return img;
			} else {
				return null;
			}
		})
	);

	str = str.replace(/<\s*drupal-media[^>]*>(.*?)<\s*\/\s*drupal-media>/g, function (m) {
		const img_uuid = m.toString().match(/data-entity-uuid\=\"([A-Za-z0-9 _-]*)\"/);
		let img_html = "";
		if (img_uuid) {
			let img = mediaReponses.filter((i) => !!i).find((i) => i.id === img_uuid[1]);
			if (img) {
				img_html = transformDataToImg(img, true);
			}
		}
		return img_html;
	});

	str = str.replace(
		/\[icon\s+([a-zA-Z0-9_-]+)(?:\s+(\d+))?(?:\s+([#a-zA-Z0-9_-]+))?\]/g,
		(match, iconName, fontSize, color) => {
			let style = "";
			if (fontSize) {
				style += `font-size:${fontSize}px;`;
			} else {
				style += `font-size: inherit;`;
			}

			if (color) style += `color:${color};`;
			const styleAttr = style ? ` style="${style}"` : "";
			return `<span class="material-symbols-outlined"${styleAttr}>${iconName}</span>`;
		}
	);

	return str;
};

function transformDataToImg(img, isMedia = false) {
	let img_html = "";
	if (img.cloudflare || img.video) {
		img_html = `<div class="drupal-media drupal-media-embed align-${
			img.align ? img.align : "none"
		}"><div>`;
		if (img.cloudflare) {
			let poster_url =
				img.src && img.src !== "" && img.src !== "/default.jpg"
					? img.src
					: `https://${generalSettings.data.siteMetaData.cloudflareClient}.cloudflarestream.com/${img.cloudflare}/thumbnails/thumbnail.jpg`;

			img_html += `<iframe
        src="https://${
					generalSettings.data.siteMetaData.cloudflareClient
				}.cloudflarestream.com/${img.cloudflare}/iframe?poster=${encodeURIComponent(
				poster_url
			)}"
        style="border: none; position: absolute; top: 0; height: 100%; width: 100%"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowfullscreen="true"
      ></iframe>`;
		} else if (img.video) {
			const YouTubeID = validateYouTubeUrl(img.video);
			const VimeoID = !YouTubeID ? validateVimeoUrl(img.video) : null;
			if (YouTubeID) {
				img_html += `<iframe src="https://www.youtube.com/embed/${YouTubeID}" frameborder="0" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>`;
			} else if (VimeoID) {
				img_html += `<iframe src="https://player.vimeo.com/video/${VimeoID}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
			} else {
				img_html += `<video controls src="${img.video}"></video>`;
			}
		}
		img_html += `</div></div>`;
	} else {
		let media_clss = `drupal-media align-${img.align ? img.align : "none"} ${
			isMedia ? "drupal-inline-media" : ""
		} ${img.width_undefined ? "width-not-set" : ""}`;
		let media_style = `${
			img.width ? `width: ${img.width}${`${img.width}`.includes("%") ? "" : "px"};` : ""
		}`;
		if (img.href)
			img_html += `<a class="${media_clss}" style="${media_style}" href="${img.href}" target="_blank">`;
		else img_html += `<div class="${media_clss}" style="${media_style}">`;
		img_html += `<figure tabindex="-1"><img src="${img.src}" alt="${img.alt}"  />`;
		if (img.caption) {
			img_html += `<figcaption>${img.caption}</figcaption>`;
		}
		img_html += `</figure>`;
		if (img.href) img_html += `</a>`;
		else img_html += `</div>`;
	}
	return img_html;
}

function unescapeHTML(str) {
	return String(str)
		.replace(new RegExp("&amp;", "g"), "&")
		.replace(new RegExp("&lt;", "g"), "<")
		.replace(new RegExp("&gt;", "g"), ">")
		.replace(new RegExp("&quot;", "g"), '"')
		.replace(new RegExp("&#39;", "g"), "'")
		.replace(new RegExp("&#x2F;", "g"), "/");
}
